<div class="app-download-container gradient-background">
  <div class="app-download-content">
    <div class="illustration mt-5">
      <img src="assets/images/app-download-illustration.png" alt="App Download Illustration">
    </div>
    <div class="message-box">
      <p class="message mb-0">Our web app is built for desktops, but don't worry—we've got the perfect solution! 🚀</p>
      <p class="message mb-0">Click the button below to download the IPV app and get the best experience. See you there! 📲✨</p>
    </div>
    <button class="download-btn mt-5" (click)="downloadApp()">DOWNLOAD NOW</button>
  </div>
</div>
